import styled from '@emotion/styled';
import getBreakpoints from './breakpoints';
import cssAttributes from './cssAttributes';
import stylesToResponsiveCssPropsByKeys from './utils/stylesToResponsiveCssPropsByKeys';
import isPropValid from '@emotion/is-prop-valid';

const translateCss = (k, v) => {
    const isValid = v && cssAttributes[k];
    const isFunction = typeof cssAttributes[k] === 'function';
    return !isValid ? '' : isFunction ? cssAttributes[k](v) : `${cssAttributes[k]}: ${v};`;
};

const cssProperties = props => {
    const breakpoints = getBreakpoints();

    const styles = Object.keys(props).reduce(
        (styles, key) => {
            if (cssAttributes[key]) {
                if (Array.isArray(props[key])) {
                    styles.responsive.push(props[key].map(value => translateCss(key, value)));
                } else {
                    styles.regular.push(translateCss(key, props[key]));
                }
            }
            return styles;
        },
        { regular: [], responsive: [] },
    );

    styles.responsive = breakpoints.reduce((result, breakpoint, i) => {
        for (let j = 0; j < styles.responsive.length; j++) {
            if (styles.responsive[j][i]) {
                result[i] = result[i]
                    ? result[i] + styles.responsive[j][i]
                    : `@media screen and (min-width: ${breakpoint}){${styles.responsive[j][i]}`;
            }
            if (result[i] && j === styles.responsive.length - 1) {
                result[i] += '}';
            }
        }
        return result;
    }, []);

    return styles.regular.join('') + styles.responsive.join('');
};

export { stylesToResponsiveCssPropsByKeys };

export default (element, options = {}, ...rest) => {
    const shouldForwardProp = prop => typeof element !== 'string' || (isPropValid(prop) && !cssAttributes[prop]);
    return styled(styled(element, { shouldForwardProp, ...options }, ...rest)(cssProperties));
};
